import styled from '@emotion/styled';
import { colorVariables, fontWeights, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const DialogHeaderContainer = styled.div`
    width: 100%;
    background-color: ${colorVariables.backgroundLighter};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${gutterSizes.base};
    font-weight: ${fontWeights.light};
    padding: ${gutterSizes.medium} 0;
`

export const Img = styled.img`
    width: 72.8px;
    height: 14px;
`;
